var step_img = document.querySelector('#step1');
var step_qty = document.querySelector('#step2');
var step_method = document.querySelector('#step3');
var file_list = '';
var hasValidFile = false;
var hasValidContactInfo = false;
var hasValidPhoneNumber = false;
var hasValidEmail = false;
var hasValidQuantity = false;
//global error
var isError = false;

const image_customization_app = document.querySelector('#image-customization-app');

const name_wrappers = document.querySelectorAll('.name-wrapper');

const item_order_note = document.querySelector('.item-order-note');

//disable submit at first
if(image_customization_app && !hasValidFile) {
  disableSubmitButton();
  if(item_order_note) item_order_note.classList.add('hidden');
}

/* attach event listener to the product form */
window.addEventListener('upload:added', function(e) {
    /* event detail contains the file reference */
    var file = e.detail;
    /* print file on console to see all attributes */
    //console.debug('file added', file);

    /* if image thumbnail is enabled
      then the event is executed twice, once for the original and once for the thumbnail
      check the file.meta.variant to decide which version this event is from
     */
    // if(file.url && file.meta.variant === 'thumbnail') {
    //   console.log('file is thumbnail!');
    // }

    /* url contains the link to the file */
    //console.log('new file: ' + file.url);
    if(file) {
      hasValidFile = true;
      validateSubmitForm(hasValidContactInfo && hasValidFile && hasValidQuantity);
      //show step 2
      if(step_qty) step_qty.classList.remove('hidden');
    }
});

window.addEventListener('upload:removed', function(e) {
    /* event detail contains the file reference */
    let file = e.detail;
    // console.log('file deleted: ' + file.url);
    var customQuantities = document.querySelectorAll('.quantity-custom-selector__value');
    customQuantities.forEach(field=>{
      field.value = 0;
    })

    if(name_wrappers) name_wrappers.forEach(field => {
      field.classList.add('hidden');
      var validation_field = document.querySelector('#validation-for-'+field.dataset.forQuantity);
      validation_field.innerHTML = '';
      validation_field.classList.add('hidden');
    });

    if(step_qty) {
      setTimeout(function() {
        step_qty.classList.add('hidden');
        step_method.classList.add('hidden');
      }, 200)
    }
    hasValidFile = false;
    item_order_note.classList.add('hidden');
    validateSubmitForm(hasValidContactInfo && hasValidFile && hasValidQuantity);
});

//increase / decrease quantity ordered
var quantity_section = document.querySelector('#step2');
var quantity_buttons = quantity_section.querySelectorAll('.quantity-selector__button--custom');

quantity_buttons.forEach((button) => {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    //custom size message
    const custom_size_msg = document.querySelector('.custom-size-message');
    //handle custom quantity
    var target_input_id = this.dataset.controls;
    var target_input = document.getElementById(target_input_id);
    var operation_type = (this.dataset.action === 'decrease-picker-quantity-custom') ? 'decrease' : 'increase';

    //validation fields
    var name_field = document.getElementById('name_'+target_input_id);
    var validation_element = document.getElementById('validation-for-'+target_input_id);

    switch(operation_type) {
      case 'increase':
        target_input.value = parseInt(target_input.value) + 1;
        break;
      case 'decrease':
        target_input.value = Math.max(0, parseInt(target_input.value) - 1);
        break;
      default: 
        break;
    }

    const name_field_wrapper = document.querySelector('div[data-for-quantity="'+target_input_id+'"]');

    // show/hide name field based on quantity
    if(target_input.value == 0) {
      name_field.value = '';
      name_field_wrapper.classList.add('hidden')
    } else {
      name_field_wrapper.classList.remove('hidden')
    }

    if(name_field.value != '') {
      var countMismatch = false, duplicated = false;
      if(countNameSeparately(name_field.value) != target_input.value) {
        countMismatch = true;
        validation_element.innerHTML = "<span>Quantity and number of names do not match.</span>";
      } 

      if(foundDuplidates(name_field.value)) {
        duplicated = true;
        validation_element.innerHTML = '<span>Duplicate names.</span>';
      }

      if(countMismatch || duplicated) {
        if(validation_element) validation_element.classList.remove('hidden');
        hasValidQuantity = false;
      } else {
        if(validation_element) validation_element.classList.add('hidden');
        hasValidQuantity = true;
      }
    } else {
      countMismatch = false;
      duplicated = false;
      hasValidQuantity = true;
      if(validation_element) validation_element.classList.add('hidden');
    }

    // if( name_field.value != '' && countNameSeparately(name_field.value) != target_input.value )
    // {
    //   validation_element.innerHTML = "Quantity and number of names do not match.";
    //   validation_element.classList.remove('hidden')
    //   disableSubmitButton();
    //   isError = true;
    // } else {
    //   validation_element.classList.add('hidden')
    //   validation_element.innerHTML = '';
    //   enableSubmitButton();
    //   isError = false;
    // }
    validateSubmitForm(customQuantityUpdate() && hasValidContactInfo && hasValidFile);
    // customQuantityUpdate();

  }, false)
});

function customQuantityUpdate() {
  var total = 0;
  var customQuantities = document.querySelectorAll('.quantity-custom-selector__value');
  var order_quantity = document.querySelector('input[name="quantity"]');
  if(customQuantities) {
    customQuantities.forEach(quantity_field => {
      var qty_value = parseInt(quantity_field.value);
      if(qty_value > 0) {
        total += qty_value;
        //setting name for adding to cart
        quantity_field.setAttribute('name', 'properties[Custom Qty '+quantity_field.getAttribute('id').replace('custom_qty_','')+']');
      }
    });
  }
  if(total != parseInt(order_quantity.value)) {
    order_quantity.value = total;
  }
  if(total == 0) {
    var delay = 100;
    hasValidQuantity = false;
    setTimeout(function() {
      step_method.classList.add('hidden');
      item_order_note.classList.add('hidden');
    }, delay);
  } else {
    hasValidQuantity = true;
    if(step_method)
    {
      setTimeout(function() {
        step_method.classList.remove('hidden');
        item_order_note.classList.remove('hidden');
      }, delay);
    }
  }
  return hasValidQuantity;
}

//color change
// document.addEventListener('variant:changed', function(event) {
  
//   const currentVariant = event.detail.variant; // The newly selected variant object
//   //console.log('Variant changed:', currentVariant);
//   var customQuantities = document.querySelectorAll('.quantity-custom-selector__value');
//   var order_quantity = document.querySelector('input[name="quantity"]');
//   if(customQuantities) {
//     customQuantities.forEach((quantity_field) => {
//       quantity_field.value = 0;
//     });
//     order_quantity.value = 0;
//     //var element = document.querySelector('.product-form__selected-value');
//     //element.html = currentVariant;
//   } 
// });

document.addEventListener('product:added', function(event) {
  var customQuantityFields = document.querySelectorAll('.quantity-custom-selector__value');
  var customNameFields = document.querySelectorAll('.add-name');
  customQuantityFields.forEach(field=>{
    field.value = 0
  });

  customNameFields.forEach(function (label, index) {
    if(index === 0) {
      label.querySelector('input').value = '';
    } else label.remove();
  })
});


function validateOrderQuantity() {
  var total = 0;
  var customQuantities = document.querySelectorAll('.quantity-custom-selector__value');
  if(customQuantities) {
    customQuantities.forEach(quantity_field => {
      var qty_value = parseInt(quantity_field.value);
      if(qty_value > 0) {
        total += qty_value;
      }
    });
    return total > 0 ?? false;
  }
}


//OLD NOT USED
// const addNameBtn = document.getElementById('add_name_button');
// if(addNameBtn) {
//   const memberNameWrapper = document.getElementById('member-name-wrapper');
//   var addBtnId = 1;
//   //bind the listener
//   addNameBtn.addEventListener('click', function(e) {
//   e.preventDefault();
//   addBtnId++;
//   const nameField = document.createElement('input');
//   const nameLabel = document.createElement('label');
//   const disableBtn = document.createElement('button');
//   //setting atrributes to label
//   nameLabel.setAttribute('for', 'properties[name_'+addBtnId+']');
//   nameLabel.className = 'product-form__info-item add-name';

//   //setting attributes to input
//   nameField.setAttribute('type', 'text');
//   nameField.setAttribute('id', 'name_'+addBtnId);
//   nameField.setAttribute('name', 'properties[name_'+addBtnId+']');
//   nameField.setAttribute('placeholder', 'Enter name');
//   nameField.className = 'custom-name-input';

//   //disable button
//   disableBtn.className = 'remove-name-button';
//   disableBtn.setAttribute('data-id', 'name_'+addBtnId);
//   disableBtn.setAttribute('type', 'button');
//   disableBtn.textContent = 'Remove';
//   disableBtn.addEventListener('click', ()=> nameLabel.remove());
  
//   //append
//   nameLabel.append(nameField);
//   nameLabel.append(disableBtn);
//   if(10 >= addBtnId) memberNameWrapper.insertBefore(nameLabel, this);

//   return true;
// })
//}

// var removeNameButtons = document.querySelectorAll('.remove-name-button');
// console.log(removeNameButtons)
// if(removeNameButtons) {
//   removeNameButtons.forEach(btn => {
//     //event for each remove button
//     btn.addEventListener('click', function(e) {
//       // e.preventDefault();
//       const removedLabel = this.parentNode;
//       removedLabel.remove();
//     });
//   });

// }
function countNameSeparately(str = '') {
  return String(str)
  .split(',')
  .map(s=>s.trim())
  .filter(Boolean)
  .length;
}

function foundDuplidates(str) {
  const seen = new Set();
  return str.split(',')
            .map(s => s.trim().toLowerCase())
            .some(name => seen.size === seen.add(name).size);
}

var custom_names = document.querySelectorAll('.custom-name-field');
if(custom_names) {
  custom_names.forEach(name_field => {
    name_field.addEventListener('blur', function(event) {
      var countMismatch = false, duplicated = false;
      var custom_names_str = this.value;
      var qtyField = document.querySelector('#'+event.target.dataset.for);
      var name_count = countNameSeparately(custom_names_str);
      var validation_element = document.querySelector('#validation-for-'+event.target.dataset.for);

      if(custom_names_str != '') {

        if(name_count != parseInt(qtyField.value)) {
          countMismatch = true;
          validation_element.innerHTML = "<span>Quantity and number of names do not match.</span>";
        } else

        if(foundDuplidates(custom_names_str)) {
          duplicated = true;
          validation_element.innerHTML = '<span>Duplicate names.</span>';
        }

      } else {
        countMismatch = false;
        duplicated = false;
        //if(validation_element) validation_element.classList.add('hidden');
      }

      if(countMismatch || duplicated) {
        if(validation_element) validation_element.classList.remove('hidden');
        hasValidQuantity = false;
      } else {
        if(validation_element) validation_element.classList.add('hidden');
        hasValidQuantity = true;
      }

      validateSubmitForm(hasValidQuantity && hasValidContactInfo && hasValidFile);
      // customQuantityUpdate();
    });
  })
}


//phone number validation & email validation
var validate_error_phone = document.querySelector('#validation__phone')
var whatsapp_field = document.querySelector('#contact-info-whatsapp');
var contactEmail = document.querySelector('#contact-info-email');
var full_phone_field = document.querySelector('#full_phone_number');

const actions = ['blur', 'input', 'keyup', 'keydown', 'change', 'copy', 'cut', 'paste', 'focus'];
const errorMap = ["Invalid phone number", "Invalid country code", "Too short", "Too long", "Invalid number"];

if(contactEmail) {
  actions.forEach((event_name) => contactEmail.addEventListener(event_name, (e) => 
    setTimeout(validateEmailField, 100, e.target)
  ))
}

const iti = window.intlTelInput(whatsapp_field, {
  initialCountry: "us",
  loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.15.0/build/js/utils.js"),
});

if(whatsapp_field) {
  actions.forEach((event_name) => whatsapp_field.addEventListener(event_name, (e) => 
    setTimeout(validatePhoneFieldIntTelInput, 100, e.target)
  ))
}

const showError = (msg) => {
  if(validate_error_phone) {
    validate_error_phone.innerHTML = msg;
    validate_error_phone.classList.remove('hidden');
  }
  whatsapp_field.classList.remove('valid');
  whatsapp_field.classList.add('invalid');
}

const reset = () => {
  whatsapp_field.classList.remove('invalid');
  whatsapp_field.classList.remove('valid');
  validate_error_phone.classList.add('hidden');
}

function validatePhoneFieldIntTelInput(ele) {
  
  if (!ele.value.trim()) {
    reset();
    hasValidPhoneNumber = false;
    hasValidContactInfo = hasValidEmail ? true : false;
  } else {
    if (iti.isValidNumber() && iti.isValidNumberPrecise()) {
      validate_error_phone.classList.add("hidden");
      ele.classList.add('valid');
      full_phone_field.value = iti.getNumber();
      hasValidPhoneNumber = true;
    } else {
      const errorCode = iti.getValidationError();
      const msg = errorMap[errorCode] || "Invalid number";
      showError(msg);
      full_phone_field.value = '';
      hasValidPhoneNumber = false;
    }
    hasValidContactInfo = (hasValidPhoneNumber || hasValidEmail) ? true : false;
  }

  validateSubmitForm(hasValidContactInfo && hasValidFile && hasValidQuantity);
}

function validateEmailField(ele) {
  const validate_error = document.querySelector('#validation__email');
  if(ele.value === null || ele.value === '') {
    hasValidEmail = false;
    hasValidContactInfo = hasValidPhoneNumber ? true : false;
    validate_error.innerHTML = ''
    validate_error.classList.add('hidden')
    ele.classList.remove('invalid')
    ele.classList.remove('valid')
  } else {
    
    if(!validateEmailAddress(ele.value)) { //invalid
      hasValidEmail = false;
      ele.classList.add('invalid')
      ele.classList.remove('valid')
      if(validate_error) {
        validate_error.innerHTML = 'Invalid email.'
        validate_error.classList.remove('hidden')
      }
    } else { //valid email
      hasValidEmail = true;
      ele.classList.remove('invalid')
      ele.classList.add('valid')
      if(validate_error) {
        validate_error.innerHTML = ''
        validate_error.classList.add('hidden')
      }
    }
    hasValidContactInfo = (hasValidPhoneNumber || hasValidEmail) ? true : false;
  }

  validateSubmitForm(hasValidContactInfo && hasValidFile && hasValidQuantity);
}

function validateEmailAddress (email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

//global add to cart
function validateSubmitForm(validForm) {
  if(validForm) 
    enableSubmitButton()
  else 
    disableSubmitButton()
}

function disableSubmitButton() {
  const submitBtn = document.querySelector('.product-form__add-button')
  if(submitBtn) submitBtn.disabled = true
}
function enableSubmitButton() {
  const submitBtn = document.querySelector('.product-form__add-button')
  if(submitBtn) submitBtn.disabled = false
}